import { useCallback, useContext, useEffect, useState } from 'react';
import { useUtils } from '../../../../context/UtilsContext';
import { modifyDepartments, modifyRoles } from '../../../../service/employeeService';
import { ApiContext } from '../../../../context/MyContext';

export function useHrReferenceData() {
  const { corporateUtils, corporateLoading, fetchCorporateUtils } = useUtils();
  const { post } = useContext(ApiContext);

  useEffect(() => {
    if (!corporateUtils) fetchCorporateUtils();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
  }, []);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const refreshCorporateUtils = useCallback(async () => {
    sessionStorage.removeItem('corporateUtils');
    await fetchCorporateUtils({ force: true });
  }, [fetchCorporateUtils]);

  const saveDepartmentRow = useCallback(async (items) => {
    setSaving(true);
    try {
      await modifyDepartments(post, { items });
      await refreshCorporateUtils();
      showToast('Saved');
      return { success: true };
    } catch (err) {
      const msg = err?.message || 'Save failed';
      showToast(msg, 'error');
      return { success: false, message: msg };
    } finally {
      setSaving(false);
    }
  }, [post, refreshCorporateUtils]);

  const saveRoleRow = useCallback(async (items) => {
    setSaving(true);
    try {
      await modifyRoles(post, { items });
      await refreshCorporateUtils();
      showToast('Saved');
      return { success: true };
    } catch (err) {
      const msg = err?.message || 'Save failed';
      showToast(msg, 'error');
      return { success: false, message: msg };
    } finally {
      setSaving(false);
    }
  }, [post, refreshCorporateUtils]);

  const departmentsWithRoles = corporateUtils?.departments_with_roles || [];

  return {
    departmentsWithRoles,
    loading: corporateLoading,
    saving,
    toast,
    saveDepartmentRow,
    saveRoleRow,
  };
}
